import { Box, Grid } from "@material-ui/core";
import { IconCar } from "icons";

export const getVehicleOptionLabel = (option) => {
    if (!option) return '';
    return `${option.descriptor || ''} ${option.assetId || ''} ${option.licensePlate || ''}`.trim();
};

export const renderVehicleOption = (props, option) => {
    const labelStyle = { fontWeight: 600, marginRight: '8px' };
    const iconStyle = { marginRight: '16px' };

    return (
        <Box {...props}>
            <Grid container xs={12} alignItems='center' justifyContent='space-between'>
                <Grid item>
                    <Grid container alignItems='center'>
                        <Grid item style={iconStyle}>
                            <IconCar width={20} height={20} />
                        </Grid>
                        <Grid item>
                            <Grid container direction='column'>
                                {option?.descriptor && (
                                    <Grid item>
                                        <label style={labelStyle}>VIN:</label>
                                        {option.descriptor}
                                    </Grid>
                                )}
                                {option?.assetId && (
                                    <Grid item>
                                        <label style={labelStyle}>Asset ID:</label>
                                        {option.assetId}
                                    </Grid>
                                )}
                                {option?.licensePlate && (
                                    <Grid item>
                                        <label style={labelStyle}>License Plate:</label>
                                        {option.licensePlate}
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};
